import * as React from 'react';
import Text from '../Text';
import {ReservationStateType} from '../../models/enums';
import {ReservationStatusBadgeProps} from './types';

export default class ReservationStatusBadge extends React.Component<ReservationStatusBadgeProps, {}> {
  public render() {
    const textProps = {letterSpacing: 0.5, fontSize: 12};
    switch (this.props.status) {
      case ReservationStateType.CONFIRMED:
        return (
          <Text color="primary" {...textProps}>
            {ReservationStateType.CONFIRMED}
          </Text>
        );
      case ReservationStateType.CHANGED:
        return (
          <Text color="lightgray" {...textProps}>
            {ReservationStateType.CHANGED}
          </Text>
        );
      case ReservationStateType.CANCELLED:
        return (
          <Text color="#C00" {...textProps}>
            {ReservationStateType.CANCELLED}
          </Text>
        );
      default:
        return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ReservationStatusBadge/ReservationStatusBadge.tsx